<template>
  <basic-container>
    <avue-crud 
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      :permission="permissionList"
      v-model="form"
      ref="crud"
      @search-change="searchChange"
      @search-reset="searchReset"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad">
      
      <template slot="menu" slot-scope="scope">
        <el-button 
          type="text"
          size="small"
          icon="el-icon-chat-dot-square"
          @click="handleViewMessages(scope.row)">
          查看消息
        </el-button>
      </template>
      
      
    </avue-crud>
  </basic-container>
</template>

<script>
import { getAiSessionList } from "@/api/aiSession";
import { mapGetters } from "vuex";
// 移除消息弹窗，改为新页面展示

export default {
  name: 'AiSession',
  
  components: {
  },
  
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 0
      },
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 24,
        border: true,
        index: true,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        selection: false,
        dialogClickModal: false,
        labelWidth: 120,
        labelPosition: 'right',
        span: 8,
        column: [
          {
            label: "UUID",
            prop: "uuid",
            span: 12,
            search: true,
            searchLabelWidth: 120,
            searchPlaceholder: "请输入用户UUID",
            rules: [{
              required: true,
              message: "请输入用户UUID",
              trigger: "blur"
            }],
            overHidden: true,
            tip: true,
            cellStyle: {
              'white-space': 'nowrap',
              'text-overflow': 'ellipsis',
              'overflow': 'hidden',
              'max-width': '200px'
            }
          },
          {
            label: "手机号码",
            prop: "phone",
            span: 12,
            search: true,
            searchLabelWidth: 120,
            searchPlaceholder: "请输入手机号码",
            display: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            showColumn: false,
            hide: true,
            overHidden: true,
            tip: true
          },
          {
            label: "会话ID",
            prop: "sessionId",
            span: 8,
            search: true,
            searchLabelWidth: 120,
            searchPlaceholder: "请输入会话ID",
            overHidden: true,
            tip: true,
            cellStyle: {
              'white-space': 'nowrap',
              'text-overflow': 'ellipsis',
              'overflow': 'hidden',
              'max-width': '150px'
            }
          },
          {
            label: "会话标题",
            prop: "title",
            span: 8,
            search: true,
            searchLabelWidth: 120,
            searchPlaceholder: "请输入会话标题",
            overHidden: true,
            tip: true,
            cellStyle: {
              'white-space': 'nowrap',
              'text-overflow': 'ellipsis',
              'overflow': 'hidden',
              'max-width': '200px'
            }
          },
          {
            label: "创建时间",
            prop: "createTime",
            span: 9,
            search: false,
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
          },
          {
            label: "最后活跃时间",
            prop: "lastTime",
            width: 150,
            span: 9,
            search: false,
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
          }
        ]
      },
      data: []
    };
  },
  
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: false,
        viewBtn: false,
        delBtn: false,
        editBtn: false
      };
    }
  },
  
  mounted() {
    // 不自动加载，等用户输入UUID后搜索
  },
  
  methods: {
    
    
    // 查看会话消息 → 跳转新页面
    handleViewMessages(row) {
      this.$router.push({
        path: '/aiSession/messages',
        query: {
          sessionId: row.sessionId,
          sessionTitle: row.title || row.sessionId
        }
      });
    },
    
    
    // 搜索重置
    searchReset() {
      this.query = {};
      this.data = [];
      this.page.total = 0;
    },
    
    // 搜索变化
    searchChange(params, done) {
      this.query = params;
      this.page.pageNum = 1;
      this.onLoad(this.page, this.query);
      done();
    },
    
    // 当前页变化
    currentChange(currentPage) {
      this.page.pageNum = currentPage;
      this.onLoad(this.page, this.query);
    },
    
    // 页大小变化
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.onLoad(this.page, this.query);
    },
    
    // 刷新
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    
    // 加载数据
    onLoad(page, params = {}) {
      this.loading = true;
      const requestData = {
        pageNum: page.pageNum,
        pageSize: page.pageSize,
        uuid: params.uuid,
        phone: params.phone,
        sessionId: params.sessionId,
        title: params.title
      };
      
      getAiSessionList(requestData).then(res => {
        if (res.data.code === 200 || res.data.code === 0) {
          const data = res.data.data;
          this.page.total = data.total;
          console.log('data.records', data.records);
          // 处理创建时间，增加8小时
          const records = data.records || [];
          this.data = records.map(item => {
            if (item.createTime) {
              const createTime = new Date(item.createTime);
              createTime.setHours(createTime.getHours() + 8);
              item.createTime = createTime.toLocaleString();
            }
            return item;
          });
          this.loading = false;
        } else {
          this.loading = false;
          this.$message.error(res.data.msg || "获取数据失败");
        }
      }).catch(error => {
        this.loading = false;
        console.error("获取AI会话列表失败:", error);
        this.$message.error("获取数据失败，请重试");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/* 设置操作栏宽度 */
.avue-crud__menu {
  min-width: 120px !important;
  width: 120px !important;
}

/* 确保操作按钮在一行显示 */
.avue-crud__menu .el-button {
  margin-right: 8px;
}

/* 表格单元格文本溢出处理 */
.el-table .cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* 确保tooltip正常显示 */
.el-tooltip__popper {
  max-width: 300px;
  word-break: break-all;
  line-height: 1.5;
}

/* 状态标签样式 */
.el-tag {
  margin: 0;
}

/* 搜索表单样式 */
.avue-crud__search {
  .el-form-item {
    margin-bottom: 18px;
  }
}

.el-table__fixed {
  height: 100% !important;
  pointer-events: none;
 
  .el-table__fixed-body-wrapper {
    pointer-events: all
  }
 
}
</style>
